export default "/images/youtube.svg?993a2994b3d0e70225e185161721f680";